import msDataProvider from "@/services/msDataProvider";
import _ from "lodash";
export class StoreService {
    private setting: any = {} as any;

    constructor() {
        this.initialize();
    }

    public getData(path: string): any {
        try {
            return _.get(this.setting, path);
        } catch (e) {
            console.log(e);
            return null;
        }
    }

    public getMetaData(path: string): any {
        try {
            return _.get(this.setting.meta, path);
        } catch (e) {
            console.log(e);
            return null;
        }
    }

    public get settingMetaData() {
        try {
            if (!this.setting.meta) {
                this.setting = {...this.setting, meta: {}};
            }
            return this.setting.meta;
        } catch (e) {
            console.log(e);
            if (!this.setting) {
                this.setting = {};
            }
            if (!this.setting.meta) {
                this.setting = {...this.setting, meta: {}};
            }
            return this.setting.meta;
        }
    }

    public async setMetaData(path: string, value: any) {
        try {
            _.set(this.settingMetaData, path, value);
            await msDataProvider.executeCommand("settingSet", this.setting);
        } catch (e) {
            console.log(e);
        }
    }

    public async setData(path: string, value: any) {
        try {
            if (path) {
                _.set(this.setting, path, value);
            } else {
                this.setting = value;
            }
            await msDataProvider.executeCommand("settingSet", this.setting);
        } catch (e) {
            console.log(e);
        }
    }

    private async initialize() {
        this.setting = await msDataProvider.getData("setting");
    }
}

export const StoreServiceInstance = new StoreService()
